import VideoPlayer from "../videoPlayer";
import tutorial from "../../assets/videos/tutorial.webm";
import { useEffect, useState } from "react";
import { FaRegCircle, FaRegDotCircle } from "react-icons/fa";
import { readableColor } from "color2k";
import variables from "../../styles/export.module.scss";

const Videos = ({ autoShift = true, autoShiftInterval = 15000 }) => {
  const videos = [
    {
      video: tutorial,
      title: "Tutorial",
      tip: null,
    },
    {
      video: null,
      title: "Tip 1",
      tip: 'Outside dimensions should be 1/8" or 3 mm smaller than the inside of your drawer.',
    },
    {
      video: null,
      title: "Tip 2",
      tip: "Move a divider by selecting it and using the arrow keys.",
    },
    {
      video: null,
      title: "Tip 3",
      tip: "Use a template as a starting point and then edit as needed.",
    },
    {
      video: null,
      title: "Tip 4",
      tip: "Undo your last move by using CTRL+Z",
    },
    {
      video: null,
      title: "Tip 5",
      tip: "Save the design to work on it later.",
    },
  ];
  const [activeVideo, setActiveVideo] = useState(0);
  /* 
  useEffect(() => {
    let shiftInterval;
    if (autoShift) {
      shiftInterval = setInterval(() => {
        if (activeVideo + 1 > videos.length - 1) {
          setActiveVideo(0);
        } else setActiveVideo(activeVideo + 1);
      }, 1000);
    }
    return () => {
      if (autoShift) clearInterval(shiftInterval);
    };
  }, []); */

  useEffect(() => {
    let shiftTimeout;
    const player = document.getElementById("videoPlayer");
    if (player) player.load();

    if (autoShift) {
      shiftTimeout = setTimeout(() => {
        if (activeVideo + 1 > videos.length - 1) {
          setActiveVideo(0);
        } else setActiveVideo(activeVideo + 1);
      }, autoShiftInterval);
    }
    return () => {
      clearTimeout(shiftTimeout);
    };
  }, [activeVideo]);

  const labelStyle = {
    color: readableColor(variables.menuBgColor),
  };

  return (
    <div
      style={{ height: "100%" }}
      className="is-flex is-flex-direction-column is-justify-content-flex-end"
    >
      <p className="settings--title title is-size-6 pb-4" style={labelStyle}>
        Tips
      </p>
      <div className="videos">
        <div className="background-overlay"></div>
        <VideoPlayer
          video={videos[activeVideo].video}
          tip={videos[activeVideo].tip}
        />
        <div className="overlay">
          <span className="tag m-4 is-primary is-size-6">
            {videos[activeVideo].title}
          </span>
          <ul className="p-4 video-switcher-dots">
            {videos.map((video, index) => (
              <li
                className="dot"
                onClick={() => {
                  setActiveVideo(index);
                }}
                key={index}
              >
                {(index !== activeVideo && <FaRegCircle />) || (
                  <FaRegDotCircle className="has-text-primary" />
                )}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Videos;
